import useArrayObject from "../../hooks/useArrayObject";
import {
  addReceipt,
  getReceipts,
  updateReceipt,
} from "../../http/api/ReceiptAPI";

const useReceiptAPI = (props) => {
  const receipts = useArrayObject();

  async function get(params = {}) {
    try {
      const res = await getReceipts(params);
      console.log(res);
      receipts.setValue(res.listReceiptInfo);
      return res.listReceiptInfo;
    } catch {}
  }

  async function insert(newReceipt) {
    try {
      const res = await addReceipt(newReceipt);
      console.log(res);
      receipts.unshift({ ...newReceipt, receiptId: res });
      return res;
    } catch {}
  }

  async function update(newReceipt) {
    try {
      const res = await updateReceipt(newReceipt);
      receipts.updateByKey("receiptId", newReceipt);
      console.log(res);
      return res;
    } catch {}
  }

  return { get, insert, update, Value: receipts.Value };
};
export default useReceiptAPI;
